<label class="label_desc_table">{{
  startDate * 1000 | date: "dd/MM/YYYY":"":"it" | titlecase
}}</label>
